import { TipoVisibilidadePoligonoTerritorio } from 'graphql/types.generated'

import { TerritorioCamadaQueryModel } from '../model-territorioMapa'

export function getDeleteCamadaMessage(camada: TerritorioCamadaQueryModel): string {
  const name = camada.nome

  const map: Record<TipoVisibilidadePoligonoTerritorio, string> = {
    [TipoVisibilidadePoligonoTerritorio.AUTOR]: `A camada “${name}” será excluída do mapa. Esta ação não pode ser desfeita.`,
    [TipoVisibilidadePoligonoTerritorio.EQUIPE]: `A camada “${name}” está visível para toda a sua equipe e será excluída para essas pessoas também. Esta ação não pode ser desfeita.`,
    [TipoVisibilidadePoligonoTerritorio.TODOS]: `A camada “${name}” está visível para todas as equipes do município e será excluída para essas pessoas também. Esta ação não pode ser desfeita.`,
    [TipoVisibilidadePoligonoTerritorio.UNIDADE_SAUDE]: `A camada “${name}” está visível para todas as equipes da unidade e será excluída para essas pessoas também. Esta ação não pode ser desfeita.`,
  }

  return map[camada.visibilidade]
}
